import { createContext, useContext } from 'react';

const UnifiedProfilesContext = createContext(null);

export function UnifiedProfilesProvider({ value, children }) {
  return (
    <UnifiedProfilesContext.Provider value={value}>{children}</UnifiedProfilesContext.Provider>
  );
}

/** Domain state shared across the Records list and a profile. */
export const useUnifiedProfiles = () => {
  const value = useContext(UnifiedProfilesContext);
  if (value == null) {
    throw new Error('useUnifiedProfiles must be used inside UnifiedProfilesProviderWrapper');
  }
  return value;
};

export default UnifiedProfilesContext;
